import { gsap } from "../../animations/gsapSetup.ts";
import { useGsapScrollTrigger } from "../../hooks/useGsapScrollTrigger.ts";
import { useReducedMotion } from "../../hooks/useReducedMotion.ts";
import { useI18n } from "../../i18n/context.tsx";
import styles from "./OfflinePrivacy.module.css";

export function OfflinePrivacy() {
  const reducedMotion = useReducedMotion();
  const { t } = useI18n();

  const ref = useGsapScrollTrigger((el) => {
    if (reducedMotion) return;

    const shield = el.querySelector(`.${styles.shieldWrap}`);
    const title = el.querySelector(`.${styles.title}`);
    const description = el.querySelector(`.${styles.description}`);
    const features = el.querySelector(`.${styles.features}`);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: "top 75%",
        toggleActions: "play none none reverse",
      },
    });

    tl.from(shield, {
      scale: 0.5,
      opacity: 0,
      duration: 0.8,
      ease: "back.out(1.7)",
    })
      .from(
        title,
        {
          y: 20,
          opacity: 0,
          duration: 0.6,
        },
        "-=0.3",
      )
      .from(
        description,
        {
          y: 20,
          opacity: 0,
          duration: 0.6,
        },
        "-=0.3",
      )
      .from(
        features,
        {
          y: 20,
          opacity: 0,
          duration: 0.6,
        },
        "-=0.2",
      );
  });

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.shieldWrap}>
        <svg
          className={styles.shield}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          role="img"
          aria-label="Privacy shield icon"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      </div>
      <h2 className={styles.title}>{t.classic.privacyTitle}</h2>
      <p className={styles.description}>{t.classic.privacyDesc}</p>
      <div className={styles.features}>
        {t.classic.privacyFeatures.map((feature) => (
          <div key={feature.label} className={styles.featureItem}>
            <span className={styles.featureValue}>{feature.value}</span>
            <span className={styles.featureLabel}>{feature.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
